<div class="auth-bg">
  <div class="auth-content">
    <div *ngIf="loading">
      <ngx-spinner></ngx-spinner>
    </div>
    <div *ngIf="error && !loading" class="row justify-content-center">
      <div class="col-md-8 text-center">
        <div class="alert alert-warning" role="alert">
          {{ errorMessage || 'Ha ocurrido un error de autenticación.' }}<br>
          <button class="btn btn-primary mt-3" routerLink="/">Volver a iniciar sesión</button>
        </div>
      </div>
    </div>
  </div>
</div>
